export enum shellViews {
  shell = "primaria-shell",
  error = "primaria-error-view",
}
